module.exports = __webpack_public_path__ + "static/media/Lecture_Series.f182c220.png";